<template>
    <main-content-wrapper>
        <h1>Potrditev soglasij</h1>
        <p>Storitev <b>{{ application }}</b> za delovanje potrebuje dodatna soglasja.</p>
        <div v-for="consent in consents">
            <v-checkbox
                    v-model="status"
                    color="primary"
                    required
                    readonly
            >
                <div slot="label">
                    {{ consent.title }}
                </div>
            </v-checkbox>
        </div>
        <v-btn depressed large block color="primary_action" @click="confirm" :loading="loading">POTRJUJEM SOGLASJA</v-btn>
    </main-content-wrapper>
</template>

<script>
    import MainContentWrapper from "../components/MainContentWrapper";
    import {applicationService} from "../services";

    export default {
        name: "ApplicationConsents",
        components: {MainContentWrapper,},
        data: vm => ({
            status: true,
            loading: false,
            consents: [
            ]
        }),
        computed: {
            application(){
                return this.$store.state.application.title;
            }
        },
        created() {
            applicationService.getRequiredConsents().then((data) =>{
                this.consents = data;
            });
        },
        mounted() {
            this.$trackPageVisit('confirm-consents-app');
        },
        methods: {
            confirm() {
                this.loading = true;
                applicationService.confirmRequiredConsents().then((data) => {
                    window.location.replace(data.redirect);
                });
            }
        }
    }

</script>

<style scoped>

</style>